import styled from 'styled-components/macro'

export const PageWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
  // background-color: ${({ theme }) => theme.bg0};
`
